import { FileElement } from 'components/TemplateEditor/slateTypes';

function fileSerializer(fileElement: FileElement) {
  const {
    data: { filename, originalFilename, type, url },
  } = fileElement;
  return `{{#file}}${JSON.stringify({
    resourceId: filename,
    fileName: originalFilename,
    type,
    localUrl: url,
  })}{{/file}}`;
}

export default fileSerializer;
